export default __webpack_public_path__ + "media/Defender.d207088b.svg";